<div *ngIf="timeregEnabled" class="container-fluid top-nav pt-1 timereport-page">

  <div class="row mt-2 ml-0 mr-0">
    <div class="col pl-0 pr-0">
      <div class="card p-3">

        <div class="d-flex justify-content-between align-items-center flex-wrap mb-3 no-print">
          <h5 class="mb-0">Time</h5>
          <div>
            <button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="exportCsv()">⬇ Export CSV</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="print()">🖨 Print</button>
          </div>
        </div>

        <div class="tabs no-print mb-3" *ngIf="canSeeTeam">
          <button type="button" class="tab-btn" [class.active]="activeTab === 'my'" (click)="setTab('my')">My time</button>
          <button type="button" class="tab-btn" [class.active]="activeTab === 'team'" (click)="setTab('team')">Team</button>
        </div>

        <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

        <div class="filter-row no-print d-flex flex-wrap align-items-end mb-3">
          <div class="mr-2 mb-2">
            <small class="d-block text-muted">From</small>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" (change)="load()">
          </div>
          <div class="mr-2 mb-2">
            <small class="d-block text-muted">To</small>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" (change)="load()">
          </div>
          <div class="mr-2 mb-2" *ngIf="activeTab === 'team'">
            <small class="d-block text-muted">Customer</small>
            <select class="form-control form-control-sm" [(ngModel)]="filterCustomerId" (change)="load()">
              <option value="">All customers</option>
              <option *ngFor="let c of customerOptions()" [value]="c.id">{{ c.name }}</option>
            </select>
          </div>
          <div class="mr-2 mb-2" *ngIf="activeTab === 'team'">
            <small class="d-block text-muted">Project</small>
            <select class="form-control form-control-sm" [(ngModel)]="filterProjectId" (change)="load()">
              <option value="">All projects</option>
              <option *ngFor="let p of projectOptions()" [value]="p.id">{{ p.title }}</option>
            </select>
          </div>
          <div class="mb-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">Reset to this month</button>
          </div>
        </div>

        <div *ngIf="loading" class="text-muted mb-3">Loading…</div>

        <div *ngIf="!loading" class="summary-cards mb-3">
          <div class="summary-card">
            <div class="summary-label">Total</div>
            <div class="summary-value">{{ hours(totalMinutes()) }}h</div>
          </div>
          <div class="summary-card">
            <div class="summary-label">Entries</div>
            <div class="summary-value">{{ entries.length }}</div>
          </div>
          <div class="summary-card" *ngIf="activeTab === 'team'">
            <div class="summary-label">People</div>
            <div class="summary-value">{{ byPerson().length }}</div>
          </div>
          <div class="summary-card">
            <div class="summary-label">Customers</div>
            <div class="summary-value">{{ byCustomer().length }}</div>
          </div>
        </div>

        <div *ngIf="!loading && activeTab === 'team'" class="row mb-3">
          <div class="col-md-4 mb-3">
            <div class="table-card">
              <h6 class="table-card-title">By person</h6>
              <table class="table table-sm mb-0">
                <tbody>
                  <tr *ngFor="let row of byPerson()">
                    <td><app-personname [personId]="row.key" [chatType]="false" [enableChange]="false"></app-personname></td>
                    <td class="text-right hours-cell">{{ hours(row.minutes) }}h</td>
                    <td class="text-right text-muted">{{ row.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="table-card">
              <h6 class="table-card-title">By customer</h6>
              <table class="table table-sm mb-0">
                <tbody>
                  <tr *ngFor="let row of byCustomer()">
                    <td>{{ row.label }}</td>
                    <td class="text-right hours-cell">{{ hours(row.minutes) }}h</td>
                    <td class="text-right text-muted">{{ row.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="table-card">
              <h6 class="table-card-title">By project</h6>
              <table class="table table-sm mb-0">
                <tbody>
                  <tr *ngFor="let row of byProject()">
                    <td>{{ row.label }}</td>
                    <td class="text-right hours-cell">{{ hours(row.minutes) }}h</td>
                    <td class="text-right text-muted">{{ row.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="!loading && activeTab === 'my'" class="row mb-3">
          <div class="col-md-6 mb-3">
            <div class="table-card">
              <h6 class="table-card-title">By customer</h6>
              <table class="table table-sm mb-0">
                <tbody>
                  <tr *ngFor="let row of byCustomer()">
                    <td>{{ row.label }}</td>
                    <td class="text-right hours-cell">{{ hours(row.minutes) }}h</td>
                    <td class="text-right text-muted">{{ row.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="table-card">
              <h6 class="table-card-title">By project</h6>
              <table class="table table-sm mb-0">
                <tbody>
                  <tr *ngFor="let row of byProject()">
                    <td>{{ row.label }}</td>
                    <td class="text-right hours-cell">{{ hours(row.minutes) }}h</td>
                    <td class="text-right text-muted">{{ row.percent }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="!loading" class="table-card">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th (click)="sortBy('workDate')" class="cursor-pointer">Date ↕</th>
                <th (click)="sortBy('customerName')" class="cursor-pointer">Customer ↕</th>
                <th (click)="sortBy('projectTitle')" class="cursor-pointer">Project ↕</th>
                <th (click)="sortBy('taskTitle')" class="cursor-pointer">Task ↕</th>
                <th *ngIf="activeTab === 'team'">Person</th>
                <th (click)="sortBy('minutes')" class="cursor-pointer text-right">Hours ↕</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of sortedEntries()">
                <td>{{ e.workDate | date:'mediumDate' }}</td>
                <td>{{ e.customerName || '—' }}</td>
                <td>{{ e.projectTitle || '—' }}</td>
                <td>{{ e.taskTitle || '—' }}</td>
                <td *ngIf="activeTab === 'team'"><app-personname [personId]="e.personId" [chatType]="false" [enableChange]="false"></app-personname></td>
                <td class="text-right hours-cell">{{ hours(e.minutes) }}h</td>
                <td class="text-muted">{{ e.note }}</td>
              </tr>
              <tr *ngIf="!entries.length">
                <td [attr.colspan]="activeTab === 'team' ? 7 : 6" class="text-center text-muted py-4">
                  No time logged in this range.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>
